import { Component } from "@angular/core";


@Component({
    templateUrl: "./menu-designer.component.html"
})
export class MenuDesignerComponent {
}